import styled from "styled-components";
import { palette } from "styled-theme";

// No specific props are being passed to this component,
// but we can define the type for extensibility
interface SummaryWrapperProps {
  className?: string;
}

const SummaryWrapper = styled.div<SummaryWrapperProps>`
  display: flex;
  height: 145px;
  .attributes {
    @media (max-width: 1100px) {
      display: none;
    }
    margin: 10px 20px 0px 0px;
    padding: 0 20px;
    border-right: 1px solid ${palette("border", 0)};
    align-self: flex-start;
  }
  .label {
    padding-bottom: 0;
  }
`;

export default SummaryWrapper;
